import styled from 'styled-components';

export const BackContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
`;

export const Container = styled.form`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  /* height: 100%; */
  max-width: 1280px;
  max-height: 90%;
  background-color: #fff;
  overflow-y: auto;
  scroll-behavior: smooth;
`;

export const ContentContainer = styled.div`
  padding: 0 2rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const TitleContainer = styled.div`
  position: sticky;
  top: 0;
  padding: 2rem 2rem 2rem 2rem;
  background-color: #fff;
  z-index: 1000;
`;

export const Title = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  color: #000;
  text-align: center;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background-color: transparent;
  outline: none;
  border: none;
  display: flex;

  &:hover {
    cursor: pointer;
  }
`;